module.exports = __webpack_public_path__ + "img/终止.e031ddb4.svg";